if (!customElements.get('emergent-product-preview')) {
  customElements.define(
    'emergent-product-preview',
    class EmergentProductPreview extends HTMLElement {
      connectedCallback() {
        this.cancelled = false;
        customElements.whenDefined('product-info').then(() => {
          if (this.cancelled) return;
          const current = new URL(window.location.href);
          const view = current.searchParams.get('view') || (['emergent-bundle-test', 'emergent-service-test', 'emergent-service-preview'].includes(this.dataset.view) ? this.dataset.view : null);
          if (!["emergent-base", "emergent-service", "emergent-cpap", "emergent-circuit", "emergent-mask", "emergent-consumable", "emergent-accessory", "emergent-bundle-test", "emergent-service-test", "emergent-service-preview"].includes(view) || view !== this.dataset.view) return;
          const root = document.querySelector(`product-info[id^="MainProduct-"][data-product-id="${this.dataset.productId}"]`);
          if (!root || typeof root.buildRequestUrlWithParams !== 'function' || typeof root.updateURL !== 'function') return;
          const productPath = new URL(root.dataset.url, current).pathname;
          const previewTheme = current.searchParams.get('preview_theme_id');
          const previewKey = ['emergent-bundle-test', 'emergent-service-test', 'emergent-service-preview'].includes(view) ? current.searchParams.get('preview_key') : null;
          const preserveContext = (value) => {
            const url = new URL(value, current);
            if (url.origin !== current.origin || url.pathname !== productPath) return value;
            url.searchParams.set('view', view);
            if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
            if (previewKey) url.searchParams.set('preview_key', previewKey);
            return `${url.pathname}${url.search}${url.hash}`;
          };
          this.root = root;
          this.originalBuild = root.buildRequestUrlWithParams;
          this.originalUpdate = root.updateURL;
          this.requestWrapper = (...args) => preserveContext(this.originalBuild.apply(root, args));
          this.updateWrapper = (...args) => {
            const result = this.originalUpdate.apply(root, args);
            if (root.dataset.updateUrl !== 'false') {
              const preserved = preserveContext(window.location.href);
              window.history.replaceState(window.history.state, '', preserved);
            }
            return result;
          };
          root.buildRequestUrlWithParams = this.requestWrapper;
          root.updateURL = this.updateWrapper;
          if (
            root.quantityInput && root.quantityForm && !root.dataset.originalSection &&
            typeof root.fetchQuantityRules === 'function' && typeof root.cartUpdateUnsubscriber === 'function' &&
            typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'
          ) {
            this.originalQuantityRefresh = root.fetchQuantityRules;
            this.quantityWrapper = () => {
              const variantId = root.productForm?.variantIdInput?.value;
              if (!variantId) return;
              const request = new URL(root.dataset.url, window.location.href);
              request.searchParams.set('variant', variantId);
              request.searchParams.set('section_id', root.dataset.section);
              root.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
              return fetch(preserveContext(request.href))
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  root.updateQuantityRules(root.dataset.section, html);
                })
                .catch((error) => console.error(error))
                .finally(() => root.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
            };
            root.fetchQuantityRules = this.quantityWrapper;
            // Trade already bound the native method during connectedCallback.
            root.cartUpdateUnsubscriber();
            this.quantitySubscription = subscribe(PUB_SUB_EVENTS.cartUpdate, this.quantityWrapper);
            root.cartUpdateUnsubscriber = this.quantitySubscription;
          }
        });
      }

      disconnectedCallback() {
        this.cancelled = true;
        if (this.requestWrapper && this.root?.buildRequestUrlWithParams === this.requestWrapper) this.root.buildRequestUrlWithParams = this.originalBuild;
        if (this.updateWrapper && this.root?.updateURL === this.updateWrapper) this.root.updateURL = this.originalUpdate;
        if (this.quantityWrapper && this.root?.fetchQuantityRules === this.quantityWrapper) {
          this.root.fetchQuantityRules = this.originalQuantityRefresh;
        }
        if (this.quantitySubscription && this.root?.cartUpdateUnsubscriber === this.quantitySubscription) {
          this.quantitySubscription();
          this.root.cartUpdateUnsubscriber = this.root.isConnected
            ? subscribe(PUB_SUB_EVENTS.cartUpdate, this.root.fetchQuantityRules.bind(this.root))
            : undefined;
        }
      }
    }
  );
}
